"use client";

import Reveal from "@/components/Reveal";
import ObfuscatedMailtoLink from "@/components/ObfuscatedMailtoLink";
import { useTranslations } from "@/i18n/LocaleProvider";

// The dark gradient "corporate event or brand collaboration" callout -- shown as a teaser on the
// homepage and again, unchanged, at the bottom of the dedicated /contact page (see contact/
// page.tsx). Full-bleed (no side margins, no rounded corners) so the gradient reaches the true
// edges of the viewport like the hero video does -- the text content stays constrained and
// centered in its own inner wrapper so it doesn't stretch to unreadable widths on a big screen.
// One component so every place this renders never visually drifts apart.
export default function CorporateCollabCard() {
  const { t } = useTranslations();
  return (
    <Reveal className="relative isolate overflow-hidden px-8 py-10 sm:px-16 sm:py-16 text-center text-white">
      <div
        className="absolute inset-0 -z-10"
        style={{
          background:
            "radial-gradient(120% 140% at 15% 15%, color-mix(in srgb, var(--accent) 90%, black) 0%, var(--ink-dark) 55%), radial-gradient(100% 120% at 100% 100%, color-mix(in srgb, var(--accent-2) 85%, black) 0%, transparent 55%)",
        }}
      />
      <div className="mx-auto max-w-lg">
        <h2 className="font-display text-3xl sm:text-4xl">{t("home.contact.title")}</h2>
        <p className="mt-4 text-white/75">{t("home.contact.body")}</p>
        <ObfuscatedMailtoLink
          email="hello@hoopyogi.com"
          className="mt-8 inline-flex rounded-xl bg-white px-7 py-3 font-semibold text-ink-dark transition hover:opacity-90"
        >
          {t("home.contact.cta")}
        </ObfuscatedMailtoLink>
      </div>
    </Reveal>
  );
}
